// src/authConfig.js

export const msalConfig = {
  auth: {
    clientId: '014a8922-efa0-48b7-a654-8e8150398c76',
    authority: 'https://login.microsoftonline.com/d5d78fa1-6a20-46c4-9b12-1d177d0459a0',
    redirectUri: 'http://localhost:3000',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read', 'Mail.Send'],
};
